<template>
  <div v-show="loading">
    <div id="overlay-loading">
      <i class="fa fa-spinner fa-spin"></i>
    </div>
  </div>
</template>
<script>
export default {
  name: 'OverlayLoading',
  props: ['loading'],
  mounted(){
  }
}
</script>
<style scoped>
  i{
    font-size: 50px;
  }
  #overlay-loading{
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    align-content: center;
    align-items: center;
    position: fixed; /* Sit on top of the page content */
    width: 100%; /* Full width (cover the whole page) */
    height: 100%; /* Full height (cover the whole page) */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.3); /* Black background with opacity */
    z-index: 99999; /* Specify a stack order in case you're using a different order for other elements */
    cursor: pointer; /* Add a pointer on hover */
  }
</style>